import { GridSkeleton } from "@/components/Skeletons";

export default function GiftingLoading() {
  return (
    <div className="w-1/3">
      <GridSkeleton columns={3} rows={8} height={2.5} />
    </div>
  );
}
